import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { pxToRem, color } from '../../utils'
import Logo from '../Logo'
import MenuMobile from './MenuMobile'
import SelectArea from '../DropDown/DropDown'
import iconLogout from '../../assets/icons/icon_logout.svg'
import iconBusca from '../../assets/icons/icon_busca.svg'
import { connect } from 'react-redux'
import Media from 'react-media'
import { searchActions, areaActions, authActions, overviewActions } from '../../actions'
import Modal from '../Modal'

const Wrapper = styled.header`
  position: fixed;
  left: 0;
  right: 0;
  background: #fff;
  width: 100%;
  height: ${pxToRem(104)};
  box-sizing: border-box;
  border-bottom: 1px solid #f4f7f9;
  display: flex;
  align-items: center;
  padding-left: ${pxToRem(15)};
  padding-right: ${pxToRem(15)};
  z-index: 999;
  flex-wrap: wrap;

  @media only screen and (max-width: 700px) {
    height: ${pxToRem('70px')};
  }
`

// até 700px a barra cai para 70px: sem a margem vertical e com a altura limitada, o
// logo (60px + 16px de margem em cima e embaixo) não passa mais da barra
const WrapperLogo = styled.div`
  text-align: left;
  margin-left: ${pxToRem(11)};

  @media only screen and (max-width: 1000px) {
    text-align: center;
    flex: 1;
    margin: ${pxToRem('16px')};
  }

  @media only screen and (max-width: 700px) {
    margin: 0 ${pxToRem(16)};

    a {
      display: flex;
      justify-content: center;
    }

    img {
      width: 160px;
      height: ${pxToRem(54)};
    }
  }
`

const LogoutLink = styled.a`
  display: flex;
  font-weight: bold;
  color: #5b666d;
  align-items: center;
  text-decoration: none;
  margin-left: auto;

  span {
    margin-right: ${pxToRem(15)};
    font-size: ${pxToRem(15)};
  }

  @media only screen and (max-width: 1050px) {
    span {
      display: none;
    }
  }
`

const DropDown = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  margin-right: ${pxToRem(15)};
  border-right: 1px solid #d3dce2;
  color: ${color.secondary};
  padding: ${pxToRem(10)} ${pxToRem(15)};
  font-weight: bold;

  label {
    font-size: ${pxToRem(16)};
    height: ${pxToRem(50)};
    line-height: ${pxToRem(50)};
  }
`

const MenuDivisor = styled.div`
  height: ${pxToRem(72)};
  width: 1px;
  background: #d3dce2;
`

const HeaderRight = styled.div`
  margin-left: auto;
  display: flex;
  padding-right: ${pxToRem(23)};
  align-items: center;

  @media only screen and (max-width: 1000px) {
    flex: 1;
    padding-right: 0;

    ${MenuDivisor}, ${DropDown} {
      flex: 0;
      display: none;
    }
  }

  @media only screen and (max-width: 1001px) {
    flex: 1;
    padding-right: 0;
  }

  @media only screen and (max-width: 700px) {
    flex: 0;
  }
`

const WrapperSearch = styled.div`
  flex: 1;
  margin-left: 0;
  height: ${pxToRem(104)};
  display: flex;
  align-items: center;
  background: #fff;
  position: relative;

  .bar {
    width: 0;
    margin: auto;
    transition: 0.2s;
    background: #eee;
    height: 2px;
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
  }

  input {
    flex: 1;
    height: 3.7em;
    box-sizing: border-box;
    outline: none;
    border: none;
    font-size: ${pxToRem(18)};
    padding-left: 1em;
    &::placeholder {
      font-style: italic;
      color: #93a2ac;
    }
    &:focus {
      & ~ .bar {
        width: 100%;
        opacity: 1;
        background: #a1acb4;
      }
    }
  }

  @media only screen and (max-width: 1000px) {
    position: absolute;
    top: ${pxToRem(104)};

    left: 0;
    right: 0;
    height: auto;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
    border-top: 1px solid #a1acb4;
  }

  @media only screen and (max-width: 700px) {
    position: absolute;
    top: ${pxToRem(70)};

    input {
      font-size: ${pxToRem(16)};
    }
  }
`

const IconBusca = styled.img`
  margin-left: ${pxToRem('33px')};

  @media only screen and (max-width: 1001px) {
    margin-left: ${pxToRem('15px')};
  }
`

const HamburguerIcon = styled.div`
  background: ${color.secondary};
  height: ${pxToRem(4)};
  width: ${pxToRem(32)};
  position: relative;
  border-radius: ${pxToRem(20)};

  &::before {
    content: '';
    position: absolute;
    background: ${color.secondary};
    height: ${pxToRem(4)};
    width: ${pxToRem(32)};
    display: block;
    top: ${pxToRem(-10)};
    border-radius: ${pxToRem(20)};
  }

  &::after {
    content: '';
    position: absolute;
    background: ${color.secondary};
    height: ${pxToRem(4)};
    width: ${pxToRem(32)};
    display: block;
    top: ${pxToRem(10)};
    border-radius: ${pxToRem(20)};
  }

  @media only screen and (max-width: 700px) {
    height: ${pxToRem(3)};
    width: ${pxToRem(26)};

    &::after,
    &::before {
      height: ${pxToRem(3)};
      width: ${pxToRem(26)};
    }

    &::after {
      top: ${pxToRem(-8)};
    }

    &::before {
      top: ${pxToRem(8)};
    }
  }
`

const HamburguerButton = styled.button`
  background: none;
  border: none;
  height: ${pxToRem(36)};
  outline: none;
  padding: 0;
  cursor: pointer;
`

const HamburguerWrapper = styled.div`
  flex: 1;

  @media only screen and (min-width: 1001px) {
    display: none;
  }

  @media only screen and (max-width: 700px) {
    flex: 0;
  }
`

const ChangeAreaModal = styled(Modal)`
  overflow: unset;
  width: ${pxToRem(280)};
`

class Header extends Component {
  constructor(props) {
    super(props)
    this.searchInputRef = React.createRef()
    this.state = {
      menuOpen: false,
      debounce: undefined,
      modalAreaOpen: false
    }
  }

  closeMenu = () => {
    document.querySelector('body').classList.remove('overflow-hidden')
    this.setState(state => {
      return {
        menuOpen: false
      }
    })
  }

  openMenu = () => {
    this.setState(state => {
      document.querySelector('body').classList.add('overflow-hidden')
      return {
        menuOpen: true
      }
    })
  }

  openAreaModal = () => {
    this.closeMenu()
    this.setState({
      modalAreaOpen: true
    })
  }

  componentWillUnmount() {
    document.querySelector('body').classList.remove('overflow-hidden')
    this.props.clearSearchText()
  }

  loadAreas = value => {
    return new Promise((resolve, reject) => {
      const debounce = setTimeout(() => {
        this.props
          .getAreas(value)
          .then(items => {
            let areas = [...items]

            if (this.props.canChangeArea) {
              areas.unshift({ value: 'all', label: "TODAS AS ÁREAS" })
            }

            resolve(areas)
          })
          .catch(err => {
            reject(err)
          })
      }, 400)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    })
  }

  valueArea = () => {
    return [
      {
        value: this.props.areaId,
        label: this.props.areaName
      }
    ]
  }

  renderSelectArea = (width = '') => {
    return (
      <SelectArea
        value={this.valueArea()}
        loadOptions={this.loadAreas}
        width={width}
        onChange={e => {
          if (e.value && e.label) {
            this.props.changeStateArea(e.value, e.label, e.code, e.areaResponsible, e.businessUnitResponsible)
            this.props.fetchOverview(e.value)
            this.props.toggleProductsTable(false)
            this.setState({
              modalAreaOpen: false
            })
          }
        }}
      />
    )
  }

  render() {
    const { openMenu, closeMenu, openAreaModal } = this

    const {
      search,
      router,
      handleChangeSearchText,
      searchValue,
      canChangeArea,
      userName = 'usuário',
      areaName = 'Área indefinida',
      accessToken
    } = this.props

    const { menuOpen, modalAreaOpen } = this.state

    if (!accessToken) return (
      <Fragment>
        <Wrapper>
          <WrapperLogo>
            <a href="/"><Logo name={'client'} width={190} height={60} /></a>
          </WrapperLogo>
        </Wrapper>
      </Fragment>
    )

    return (
      <Fragment>
        <Wrapper>
          <HamburguerWrapper>
            <HamburguerButton menuOpen={menuOpen} onClick={openMenu}>
              <HamburguerIcon />
            </HamburguerButton>
            <MenuMobile
              router={router}
              open={menuOpen}
              closeMenu={closeMenu}
              userName={userName}
              areaName={areaName}
              openAreaModal={openAreaModal}
              canChangeArea={canChangeArea}
            />
          </HamburguerWrapper>

          <WrapperLogo>
            <a href="/"><Logo name={'client'} width={190} height={60} /></a>
          </WrapperLogo>

          {search ? (
            <WrapperSearch>
              <IconBusca src={iconBusca} aria-hidden="true" />
              <input
                id="search-header"
                tabIndex="0"
                name="search-header"
                type="text"
                ref={this.searchInputRef}
                placeholder="Encontre o produto que procura"
                onChange={e => handleChangeSearchText(e.target.value)}
                value={searchValue}
              />
              <span className="bar" />
            </WrapperSearch>
          ) : null}

          <HeaderRight>
            <Media query="(min-width: 1001px)">
              <Fragment>
                <MenuDivisor />
                <DropDown>{this.renderSelectArea('350px')}</DropDown>
              </Fragment>
            </Media>
            <LogoutLink href="/sair" aria-label="Sair" title="Sair">
              <span>{`Olá ${userName}`}</span>
              <img src={iconLogout} alt="Logout" aria-hidden="true" />
            </LogoutLink>
          </HeaderRight>
        </Wrapper>

        <ChangeAreaModal
          title={'Trocar área'}
          loading={false}
          open={modalAreaOpen}
          closeMethod={() => {
            this.setState({
              modalAreaOpen: false
            })
          }}
        >
          <Media query="(max-width: 1000px)">
            {matches => (matches ? this.renderSelectArea('210px') : null)}
          </Media>
        </ChangeAreaModal>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    searchValue: state.search.value,
    userName: state.auth.userName,
    areaId: state.auth.areaId,
    areaName: state.auth.areaName,
    areaCode: state.auth.areaCode,
    canChangeArea: state.auth.canChangeArea,
    accessToken: state.headers.accessToken
  }
}

const mapDispatchToProps = dispatch => {
  return {
    toggleProductsTable: (value) => {
      return dispatch(overviewActions.toggleProductsTable(value))
    },
    fetchOverview: areaId => {
      dispatch(overviewActions.fetchOverview(areaId))
    },
    handleChangeSearchText: value => {
      dispatch(searchActions.handleChangeSearchText(value))
    },
    getAreas: value => {
      return dispatch(areaActions.fetchAreas(value))
    },
    changeStateArea: (areaId, areaName, areaCode, areaResponsible, businessUnitResponsible) => {
      return dispatch(authActions.changeStateArea(areaId, areaName, areaCode, areaResponsible, businessUnitResponsible))
    },
    clearSearchText: () => {
      dispatch(searchActions.clearSearchText())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)



// WEBPACK FOOTER //
// ./src/components/Header/header.js